import {FC, useCallback} from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import Button from "@memaro/components/Button.tsx";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";
import {styled} from "@mui/material/styles";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {ThemeName} from "@memaro/themes";
import {SelectChangeEvent} from "@mui/material/Select/SelectInput";

export type EditBottomBarProps = {
    theme: ThemeName
    onChangeTheme: (theme: ThemeName) => void
    onCancel: () => void
    onSave: () => void
    saving: boolean
}

const StyledAppBar = styled(AppBar)({
    top: 'auto',
    bottom: 0,
})

const StyledToolbar = styled(Toolbar)({
    display: "flex",
    gap: 10,
})

const EditBottomBar: FC<EditBottomBarProps> = ({theme, onChangeTheme, onCancel, onSave, saving}) => {
    const handleChangeTheme = useCallback(
        (event: SelectChangeEvent<ThemeName>) => onChangeTheme(event.target.value as ThemeName),
        [onChangeTheme],
    );

    return (
        <StyledAppBar position="fixed" color="secondary">
            <StyledToolbar>
                <Button onClick={onCancel} disabled={saving}>
                    <CancelIcon/>
                    <span>Annuleren</span>
                </Button>
                <Box sx={{flexGrow: 1}}>
                    <Select<ThemeName> value={theme} onChange={handleChangeTheme} size="small">
                        <MenuItem value="default">Beige</MenuItem>
                        <MenuItem value="anthracite">Antraciet</MenuItem>
                    </Select>
                </Box>
                <Button onClick={onSave} color="success" loading={saving}>
                    <SaveIcon/>
                    <span>Opslaan</span>
                </Button>
            </StyledToolbar>
        </StyledAppBar>
    )
}

export default EditBottomBar
